<template>
  <div class="project-list">
    <ul class="training-area-items">
      <li class="no-content-list" v-if="project.records && project.records.length === 0">
        <img :src="emptyImgUrl" alt="">
        <span>{{searchKey ? '未检索到符合条件的项目' : (teacherOrStudentState ? '当前无项目，开始创建吧~' : '当前无项目')}}</span>
      </li>
      <li
        class="item"
        v-for="(item, idx) in project.records"
        :key="idx"
        @click="redirectToTraining(item)"
      >
        <div class="info">
          <div class="name ellipsis">
            {{ item.projectName }}
            <span :class="['handle-left', getProTypeClassName(item.proType)]">
              {{ item.proType | getProTypeName }}
            </span>
            <slot name="head" :project="item"> </slot>
          </div>

          <p class="text">
            <!-- 基于实训指导书，进行智能摄像头、音响与AI   
            Training平台连接，利用相关AI模型训练数据集进行模型训练，最后进行编程以及AI模型调用，实现智慧建筑场景中的安全帽识别与预警等智能应用体验。 -->
            <slot name="content" :project="item"></slot>
          </p>
          <slot name="foot" :project="item"></slot>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
// import GatPopup from "@/components/common/GatPopup";
// import IconInfoHelp from "@/components/icons/typography/InfoHelp";
// import { type } from "os";

export default {
  name: "project-list",
  // components: { GatPopup, IconInfoHelp },
  props: ["project", "searchKey"],
  data() {
    return {
      teacherOrStudentState: false,
      emptyImgUrl: require('@/assets/images/datasetLobby/icon-empty-box.png'),
    };
  },
  filters: {
    getProTypeName(proType) {
      let proTypeName = '其他'
      if (proType == 1) {
        proTypeName = '编程'
      } else if (proType == 2) {
        proTypeName = '硬件'
      } else if (proType == 3) {
        proTypeName = '数据'
      } else if (proType == 4) {
        proTypeName = '行业'
      }
      return proTypeName
    },
  },
  computed: {},
  watch: {},
  created() {
    // 获取用户身份（老师/学生/管理员）
    let userRole = this.$store.state.userRole
    if (userRole == 2) {
      // 学生
      this.teacherOrStudentState = false
    } else {
      // 老师、管理员、超级管理员
      this.teacherOrStudentState = true
    }
  },
  mounted() {
    // console.log(this.project);
  },
  methods: {
    getProTypeClassName(proType) {
      let className = ''
      if (proType == 1) {
        className = 'programming-bg-color'
      } else if (proType == 2) {
        className = 'hardware-bg-color'
      } else if (proType == 4) {
        className = 'industry-bg-color'
      }
      return className
    },
    redirectToTraining(project) {
      this.$emit("redirecTo", project);
    }
  }
};
</script>

<style lang="scss" scoped>
.training-area-items {
  margin-top: 30px;
  .no-content-list {
    // color: $page_nav_font_color;
    width: 300px;
    height: 560px;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 134px;
      height: 80px;
    }
    span {
      // color: $page_nav_font_color;
      color: #BDC3D2;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      margin-top: 16px;
    }
  }
  .item {
    width: 100%;
    height: 180px;
    margin-bottom: 20px;
    padding: 0 20px;
    border: 1px solid #dfe4f1;
    box-sizing: border-box;
    background: #fff;
    cursor: pointer;
    transition: all 0.2s ease;
    .icon {
      display: inline-block;
      width: 50px;
      height: 50px;
    }
    .info {
      padding: 28px 10px;
    }
    .name {
      font-size: 18px;
      color: #333;
      .handle {
        float: right;
        .right {
          margin-right: 10px;
          color: #666;
          cursor: pointer;
          .icons {
            font-size: 22px;
            margin-right: 5px;
            font-weight: 300;
            &.collected {
              color: #e09404;
              // font-size: 26px;
            }
            &.line {
              height: 18px;
              margin-left: 5px;
              margin-right: 8px;
            }
          }
          &:nth-child(1):hover {
            color: #4c88ff;
          }
          &:nth-child(3):hover .icons {
            color: #e09404;
            &.el-icon-delete {
              color: #4c88ff;
            }
          }
        }
      }
      .handle-left {
        display: inline-block;
        width: 43px;
        height: 20px;
        background: #ccc;
        border-radius: 10px 0px 10px 0px;
        margin-left: 6px;
        font-size: 14px;
        color: #ffffff;
        line-height: 20px;
        text-align: center;
      }
      .programming-bg-color {
        background: #F441F4;
      }
      .hardware-bg-color {
        background: #903CED;
      }
      .data-bg-color {
        background: #FE9922;
      }
      .industry-bg-color {
        background: #50ABEB;
      }
    }
    .text {
      height: 2.8em;
      font-size: 14px;
      color: #666;
      margin: 20px 0;
      line-height: 1.4;
      word-wrap: break-word;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      // text-indent: 2em;
    }
    .record {
      font-size: 14px;
      color: #666;
      .bottom {
        margin-right: 25px;
        .icons {
          font-size: 18px;
          margin-right: 12px;
          font-weight: 600;
          vertical-align: -2px;
        }
      }
    }
    .edit {
      position: relative;
      top: 1px;
      display: inline-block;
      width: 21px;
      height: 23px;
      margin-left: 40px;
      margin-right: 14px;
      cursor: pointer;
      background: url("../../../public/images/ico15.png") no-repeat;
      z-index: 1;
    }
    .line {
      position: relative;
      top: 2px;
      display: inline-block;
      width: 1px;
      height: 24px;
      margin-right: 12px;
      background: #c0c6cc;
    }
    .delete {
      position: relative;
      display: inline-block;
      width: 24px;
      height: 25px;
      cursor: pointer;
      background: url("../../../public/images/ico16.png") no-repeat;
      z-index: 1;
    }
    &:hover {
      border: 1px solid #3f7efc;
      box-shadow: 0 2px 15px 0 #d8e3f9;
      transform: translateY(-4px);
    }
  }
}
.el-icon-star-on {
  font-size: 22px;
  margin-right: 5px;
  color: #e09404;
}
</style>
